import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import {
  Section,
  SectionHeader,
  Heading,
  Paragraph,
  Box,
  UnorderedList,
  Button,
  Image,
  Link,
} from 'components';
import './Technology.scss';

const Technology = () => (
  <StaticQuery
    query={graphql`
      query {
        Eres: file(relativePath: { eq: "technology/technology-eres.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 300) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        Eye: file(relativePath: { eq: "technology/blue-eye.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 280) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        Team: file(relativePath: { eq: "technology/working-team.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 280) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => (
      <>
        <Section
          id={'technology'}
          additionalClass={'technology'}
          color={'ebony-clay'}
        >
          <SectionHeader
            description={
              'We choose technology to suit your product, specific business goals and stage of innovation. Our stack includes:'
            }
            color={'white'}
            lineColor={'white'}
            descriptionColor={'white'}
          >
            Technology
          </SectionHeader>
        </Section>
        <Section
          color={'ebony-clay'}
          additionalClass={'technology__details'}
          fullwidth
        >
          <div className={'technology__stack'}>
            <div className={'technology__category'}>
              <Box
                additionalClass={
                  'box--fitted technology__box anim-fade-in-bottom'
                }
                backgroundColor={'carrara'}
              >
                <SectionHeader
                  size={'medium'}
                  color={'red'}
                  additionalClass={'technology__category-name'}
                >
                  Web technology
                </SectionHeader>
                <UnorderedList
                  additionalClass={'text--black'}
                  columns={2}
                  items={[
                    'Java',
                    'JavaScript',
                    'Python',
                    'PHP',
                    'Node.js',
                    'Angular',
                    'React',
                    'Django',
                    'Symfony',
                  ]}
                />
                <Link
                  id={'discover-digital-transformation'}
                  to={'/blog/case-study-eres-yachting-booking-platform/'}
                >
                  <Box
                    additionalClass={'box--fitted technology__tile'}
                    backgroundColor={'red'}
                  >
                    <div className={'technology__info'}>
                      <Heading
                        size={'medium-plus'}
                        type={3}
                        additionalClass={'technology__headline'}
                        color={'white'}
                      >
                        Digital
                        <br />
                        transformation
                      </Heading>
                      <Paragraph
                        size={'default'}
                        color={'white'}
                        additionalClass={'text--light'}
                      >
                        Read about our Services:
                      </Paragraph>
                    </div>
                    <Button color={'white'} transparent>
                      Discover
                    </Button>
                  </Box>
                </Link>
                <Image
                  src={data.Team.childImageSharp.fluid}
                  alt={'Team at work'}
                  additionalClass={'technology__image'}
                  style={{
                    width: '280px',
                    height: '280px',
                  }}
                />
              </Box>
            </div>
            <div className={'technology__category'}>
              <Box
                additionalClass={
                  'box--fitted technology__box anim-fade-in-bottom'
                }
                backgroundColor={'carrara'}
              >
                <SectionHeader
                  size={'medium'}
                  color={'pigeon-post-dark'}
                  additionalClass={'technology__category-name'}
                >
                  Mobile technology
                </SectionHeader>
                <UnorderedList
                  additionalClass={'text--black'}
                  columns={1}
                  items={[
                    'iOS',
                    'Android',
                    'Windows/UWP',
                    'Xamarin',
                    'React Native',
                  ]}
                />
                <Link
                  id={'discover-design-and-development'}
                  to={'/blog/case-story-blablacar/'}
                >
                  <Box
                    additionalClass={'box--fitted technology__tile'}
                    backgroundColor={'pigeon-post-dark'}
                  >
                    <div className={'technology__info'}>
                      <Heading
                        size={'medium-plus'}
                        type={3}
                        additionalClass={'technology__headline'}
                        color={'white'}
                      >
                        Product design
                        <br />
                        &amp; development
                      </Heading>
                      <Paragraph
                        size={'default'}
                        color={'white'}
                        additionalClass={'text--light'}
                      >
                        Read about our Services:
                      </Paragraph>
                    </div>
                    <Button color={'white'} transparent>
                      Discover
                    </Button>
                  </Box>
                </Link>
                <Image
                  src={data.Eres.childImageSharp.fluid}
                  alt={'Application'}
                  additionalClass={'technology__image'}
                  style={{
                    width: '280px',
                    height: '280px',
                  }}
                />
              </Box>
            </div>
            <div className={'technology__category'}>
              <Box
                additionalClass={
                  'box--fitted technology__box anim-fade-in-bottom'
                }
                backgroundColor={'carrara'}
              >
                <SectionHeader
                  size={'medium'}
                  color={'violet'}
                  additionalClass={'technology__category-name'}
                >
                  Machine learning
                </SectionHeader>
                <UnorderedList
                  additionalClass={'text--black'}
                  columns={2}
                  items={[
                    'Python',
                    'Scikit-learn',
                    'Pandas',
                    'TensorFlow',
                    'Keras',
                    'XGBoost',
                    'OpenCV',
                    'NLTK',
                    'Gensim',
                    'Theano',
                    'PyMC',
                    'PySpark',
                  ]}
                />
                <Link
                  id={'discover-machine-learning'}
                  to={'/work/case-study-predictive-maintenance/'}
                >
                  <Box
                    additionalClass={'box--fitted technology__tile'}
                    backgroundColor={'violet'}
                  >
                    <div className={'technology__info'}>
                      <Heading
                        size={'medium-plus'}
                        type={3}
                        additionalClass={'technology__headline'}
                        color={'white'}
                      >
                        Machine
                        <br />
                        learning
                      </Heading>
                      <Paragraph
                        size={'default'}
                        color={'white'}
                        additionalClass={'text--light'}
                      >
                        Read about our Services:
                      </Paragraph>
                    </div>
                    <Button color={'white'} transparent>
                      Discover
                    </Button>
                  </Box>
                </Link>
                <Image
                  src={data.Eye.childImageSharp.fluid}
                  alt={'Focused eye'}
                  additionalClass={'technology__image'}
                  style={{
                    width: '280px',
                    height: '280px',
                  }}
                />
              </Box>
            </div>
          </div>
        </Section>
      </>
    )}
  />
);

export default Technology;
